import styled from "styled-components";
import ReactFullpage from "@fullpage/react-fullpage";
import { AvailablePositions, ContactUsGetInTouch, JoinOurTeam } from "./ContactUsGetInTouch";
import { ContactUsHeroSection } from "./ContactUsHeroSection";
import { ContactUsJoinTeam } from "./ContactUsJoinTeam";
import { MainFooter } from "../../Footer/MainFooter";
import { useState, useEffect } from "react";
import { ContactUsPrimaryContact } from "./ContactUsPrimaryContact";
import { ContactUsAdditionalContact } from "./ContactUsAdditionalContact";
import { RAButtonBackToTop } from "@/components/customs";
import { useHeaderSolid } from "@/hooks/HeaderSolidContext";
import { Grid } from "antd";

const { useBreakpoint } = Grid;

const FULL_PAGE_API_KEY = process.env.NEXT_PUBLIC_FULL_PAGE_API_KEY;

export function ContactUsSnap({ pageContent = {}, desktop = false }) {
	const { lg } = useBreakpoint();
	const { content = {} } = pageContent;
	const [activeSlide, setActiveSlide] = useState(0);
	const [openMenu, setOpenMenu] = useState(false);
	const { headerSolid } = useHeaderSolid();

	useEffect(() => {
		return () => {
			fullpage_api.silentMoveTo(1);
		};
	}, []);

	useEffect(() => {
		if (window.location.hash && window.location.hash === "#career") {
			fullpage_api.moveTo(desktop ? 4 : 5);
			setActiveSlide(desktop ? 4 : 5);
		}
		if (window.location.hash && window.location.hash === "#contact-us-get-in-touch") {
			fullpage_api.moveTo(desktop ? 5 : 6);
			setActiveSlide(desktop ? 5 : 6);
		}
	}, [window.location]);

	const onLeave = (origin, destination, direction) => {
		setActiveSlide(destination.index);
		headerSolid(destination.index);
		// arguments are mapped in order of fullpage.js callback arguments do something
		// with the event
		setOpenMenu(false);
	};

	return (
		<Container>
			{desktop ? (
				<ReactFullpage
					licenseKey={FULL_PAGE_API_KEY}
					onLeave={onLeave}
					bigSectionsDestination={"top"}
					scrollingSpeed={1100}
					fadingEffect={true}
					normalScrollElements=".ant-picker-panel-container, .ant-modal, .ant-picker-time-panel-column, .mapboxgl-canvas, .ant-modal-wrap, .ra-search-airport-ant-select-dropdown"
					credits={{ enabled: false }}
					lazyLoading={false}
					render={({ state, fullpageApi }) => {
						return (
							<ReactFullpage.Wrapper>
								<div className="section" id="contact-us-hero-section">
									<ContactUsHeroSection
										banner={content?.banner}
										onPressMessageUs={() => {
											fullpage_api.moveTo(5);
										}}
										onPressContactInfo={() => {
											fullpage_api.moveTo(2);
										}}
										onPressEmployment={() => {
											fullpage_api.moveTo(4);
										}}
										openMenu={openMenu}
										setOpenMenu={setOpenMenu}
										showMenu={true}
									/>
								</div>
								<EachSlide className="section fp-auto-height" id="contact-us-primary-contact">
									<BodyJoinTeamContainer>
										<BodyMediumContainer>
											<ContactUsPrimaryContact primary_contact={content?.primary_contact} />
										</BodyMediumContainer>
									</BodyJoinTeamContainer>
								</EachSlide>
								<EachSlide
									className="section"
									id="contact-us-hero-image"
									style={{
										justifyContent: "flex-center",
										backgroundImage: `url("/images/private-jet-travel/private-jet-travel-mask.png")`,
										backgroundRepeat: "no-repeat",
										backgroundSize: "cover",
									}}
								>
									<BodyExperienceContainer>
										<LayoutOverlay>
											<BodyMediumContainer>
												<ContactUsAdditionalContact
													additional_contact={content?.additional_contact}
												/>
											</BodyMediumContainer>
										</LayoutOverlay>
									</BodyExperienceContainer>
								</EachSlide>
								<EachSlide className="section fp-auto-height" id="career">
									<BodyJoinTeamContainer>
										<BodyMediumContainer>
											<ContactUsJoinTeam
												joining_our_team={content?.joining_our_team}
												available_positions={content?.available_positions}
											/>
										</BodyMediumContainer>
									</BodyJoinTeamContainer>
								</EachSlide>
								<EachSlide
									className="section fp-auto-height"
									id={lg ? "contact-us-get-in-touch" : undefined}
								>
									<BodyJoinTeamContainer>
										<BodyMediumContainer>
											<ContactUsGetInTouch get_in_touch_with_us={content?.get_in_touch_with_us} />
										</BodyMediumContainer>
									</BodyJoinTeamContainer>
								</EachSlide>
								<EachSlide className="section fp-auto-height" id="footer-section">
									<footer
										style={{
											width: "100%",
											scrollSnapAlign: "end",
										}}
									>
										<MainFooter />
										<RAButtonBackToTop onClick={() => fullpage_api.moveTo(1)} />
									</footer>
								</EachSlide>
							</ReactFullpage.Wrapper>
						);
					}}
				/>
			) : (
				<ReactFullpage
					licenseKey={FULL_PAGE_API_KEY}
					onLeave={onLeave}
					bigSectionsDestination={"top"}
					scrollingSpeed={1100}
					fadingEffect={true}
					normalScrollElements=".ant-picker-panel-container, .ant-modal, .ant-picker-time-panel-column, .mapboxgl-canvas, .ant-modal-wrap, .ra-search-airport-ant-select-dropdown"
					credits={{ enabled: false }}
					lazyLoading={false}
					render={({ state, fullpageApi }) => {
						return (
							<ReactFullpage.Wrapper>
								<div className="section" id="contact-us-hero-section">
									<ContactUsHeroSection
										banner={content?.banner}
										onPressMessageUs={() => {
											fullpage_api.moveTo(6);
										}}
										onPressContactInfo={() => {
											fullpage_api.moveTo(2);
										}}
										onPressEmployment={() => {
											fullpage_api.moveTo(5);
										}}
										openMenu={openMenu}
										setOpenMenu={setOpenMenu}
										showMenu={true}
									/>
								</div>
								<EachSlide className="section fp-auto-height" id="contact-us-primary-contact">
									<BodyJoinTeamContainer>
										<BodyMediumContainer>
											<ContactUsPrimaryContact primary_contact={content?.primary_contact} />
										</BodyMediumContainer>
									</BodyJoinTeamContainer>
								</EachSlide>
								<EachSlide
									className="section"
									id="contact-us-hero-image"
									style={{
										justifyContent: "flex-center",
										backgroundImage: `url("/images/private-jet-travel/private-jet-travel-mask.png")`,
										backgroundRepeat: "no-repeat",
										backgroundSize: "cover",
									}}
								>
									<BodyExperienceContainer>
										<LayoutOverlay>
											<BodyLargeContainer>
												<ContactUsAdditionalContact
													additional_contact={content?.additional_contact}
												/>
											</BodyLargeContainer>
										</LayoutOverlay>
									</BodyExperienceContainer>
								</EachSlide>
								<EachSlide className="section">
									<BodyTravelCardContainer>
										<JoinOurTeam joining_our_team={content?.joining_our_team} />
									</BodyTravelCardContainer>
								</EachSlide>
								<EachSlide className="section" id="career">
									<BodyTravelCardContainer>
										<AvailablePositions available_positions={content?.available_positions} />
									</BodyTravelCardContainer>
								</EachSlide>
								<EachSlide
									className="section fp-auto-height"
									id={lg ? "contact-us-get-in-touch" : undefined}
								>
									<BodyJoinTeamContainer>
										<BodyLargeContainer>
											<ContactUsGetInTouch get_in_touch_with_us={content?.get_in_touch_with_us} />
										</BodyLargeContainer>
									</BodyJoinTeamContainer>
								</EachSlide>
								<EachSlide className="section fp-auto-height" id="footer-section">
									<footer
										style={{
											width: "100%",
											scrollSnapAlign: "end",
										}}
									>
										<MainFooter />
										<RAButtonBackToTop onClick={() => fullpage_api.moveTo(1)} />
									</footer>
								</EachSlide>
							</ReactFullpage.Wrapper>
						);
					}}
				/>
			)}
		</Container>
	);
}

const Container = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
`;
const BodyContainer = styled.div`
	padding: 0px 136px 0px;
	width: 100%;
	max-width: 1442px;
	height: 100vh;
	display: flex;
	justify-content: center;
	align-items: center;
	@media (max-width: 1200px) {
		padding: 80px 40px;
	}
	@media (max-width: 991px) {
		padding: 60px 32px;
	}
	@media (max-width: 767px) {
		padding: 32px 24px;
	}
	@media (max-width: 575px) {
		padding: 24px 16px;
	}
`;
const BodyJoinTeamContainer = styled.div`
	width: 100%;
	height: 100vh;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	align-items: center;
	overflow: hidden;
`;
const EachSlide = styled.section`
	width: 100vw;
	transition: all 0.6s linear;
`;
const LayoutOverlay = styled.div`
	width: 100vw;
	height: 100%;
	background: rgba(249, 249, 249, 0);
	display: flex;
	justify-content: center;
	align-items: flex-start;
`;
const BodyExperienceContainer = styled.div`
	width: 100%;
	display: flex;
	justify-content: center;
`;
const BodyMediumContainer = styled.div`
	max-width: 1442px;
	padding: 84px;
	width: 100%;
	height: 100vh;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	@media (max-width: 991px) {
		padding: 44px;
		height: auto;
	}
	@media (max-width: 767px) {
		padding: 30px 32px;
		height: auto;
	}
	@media (max-width: 575px) {
		padding: 20px 16px;
		height: auto;
	}
`;
const BodyLargeContainer = styled.div`
	max-width: 1442px;
	padding: 84px;
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	@media (max-width: 991px) {
		padding: 44px;
		height: auto;
	}
	@media (max-width: 767px) {
		padding: 30px 32px;
		height: auto;
	}
	@media (max-width: 575px) {
		padding: 20px 16px;
		height: auto;
	}
`;
const BodyTravelCardContainer = styled.div`
	max-width: 1442px;
	padding: 84px;
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	@media (max-width: 991px) {
		padding: 0 80px;
	}
	@media (max-width: 767px) {
		padding: 0 32px;
	}
	@media (max-width: 575px) {
		padding: 0 16px;
	}
`;
